/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ReportCategory } from '../../models/report-category';

export interface ReportCategoryPut$Params {
  id: number;
      body: ReportCategory
}

export function reportCategoryPut(http: HttpClient, rootUrl: string, params: ReportCategoryPut$Params, context?: HttpContext): Observable<StrictHttpResponse<ReportCategory>> {
  const rb = new RequestBuilder(rootUrl, reportCategoryPut.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ReportCategory>;
    })
  );
}

reportCategoryPut.PATH = '/api/ReportCategory/{id}';
